import { playerLabel } from "@softmax/web-ux/player-label";
import { type PreviewStanding } from "../content/preview-competition.types";
const maxBoardRows = 5;
function formatBoardScore({
  score,
  valueType,
}: {
  score: number;
  valueType: "number" | "integer" | "string" | "boolean" | "percent";
}): string {
  const abs = Math.abs(score);

  if (abs >= 1000000) return `${(score / 1000000).toFixed(1)}M`;

  if (abs >= 10000) return `${Math.round(score / 1000)}k`;

  if (valueType === "integer" || Number.isInteger(score)) {
    return String(Math.round(score));
  }

  if (valueType === "percent") return `${Math.round(score)}%`;

  return score.toFixed(1);
}
export function standingsFrom(
  entries: {
    rank: number;
    player_id: string;
    player_name?: string | null;
    owner_name?: string | null;
    policy_label?: string | null;
    score: number;
    score_value_type: "number" | "integer" | "string" | "boolean" | "percent";
    rounds_played: number;
  }[],
): PreviewStanding[] {
  return entries.slice(0, maxBoardRows).map((entry) => ({
    rank: String(entry.rank).padStart(2, "0"),
    playerId: entry.player_id,
    name: entry.player_name?.trim()
      ? playerLabel({
          name: entry.player_name.trim(),
          ownerName: entry.owner_name ?? null,
        })
      : "Unnamed player",
    policy: entry.policy_label?.trim() || null,
    score: formatBoardScore({
      score: entry.score,
      valueType: entry.score_value_type,
    }),
    scoreValue: entry.score,
    roundsPlayed: entry.rounds_played,
  }));
}
